import React from 'react';
import AutenticacaoConsumer from '../../providers/autenticacao/AutenticacaoConsumer';
import { Loading } from '../../presentations';

function LogoutCallbackPage() {
    return (<AutenticacaoConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return (<Loading />);
        }}
    </AutenticacaoConsumer>);
}

export default LogoutCallbackPage;